// extracted by mini-css-extract-plugin
export default {"loader-wrapper":"Loader_loader-wrapper__wlB2r","loader_text":"Loader_loader_text__rFTFO","loader":"Loader_loader__De3pH","spin":"Loader_spin__dQne3"};